import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  CircularProgress,
  alpha,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LogoutIcon from "@mui/icons-material/Logout";

const LogoutDialog = ({ open, onClose, onConfirm, loading }) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={loading ? null : onClose}
      maxWidth='xs'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0px 12px 32px rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      <DialogContent sx={{ pt: 5, pb: 2, px: 4, textAlign: "center" }}>
        <IconButton
          onClick={onClose}
          disabled={loading}
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            color: "text.secondary",
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>

        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: alpha(theme.palette.error.light, 0.15),
            color: "error.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2.5,
          }}
        >
          <LogoutIcon sx={{ fontSize: 36 }} />
        </Box>

        <Typography variant='h6' sx={{ fontWeight: 700, mb: 1 }}>
          Log out?
        </Typography>

        {/* 说明文案 */}
        <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
          Are you sure you want to end your session? You will need to sign in
          again to access your account.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, justifyContent: "center", gap: 2 }}>
        <Button
          onClick={onClose}
          variant='outlined'
          disabled={loading}
          sx={{ minWidth: 120 }}
        >
          Stay logged in
        </Button>

        <Button
          onClick={onConfirm}
          variant='contained'
          color='error'
          disabled={loading}
          sx={{ minWidth: 120 }}
        >
          {loading ? (
            <CircularProgress size={24} color='inherit' />
          ) : (
            "Yes, log out"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutDialog;
